var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCiscoDigitalPlatformsAndTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 45.25,
    width: 12,
    height: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2002,42.75H27.25v2.5H20v1.5H33.25V58.74023A1.98286,1.98286,0,0,0,35.2002,60.75H51.25v2.5H44v1.5H60v-1.5H52.75v-2.5H68.7998A1.98286,1.98286,0,0,0,70.75,58.74023v-21.48A1.98329,1.98329,0,0,0,68.7998,35.25H46.75V19.26025A1.98329,1.98329,0,0,0,44.7998,17.25H11.2002A1.98329,1.98329,0,0,0,9.25,19.26025v21.48A1.98286,1.98286,0,0,0,11.2002,42.75ZM33.25,45.25h-4.5v-2.5h4.5Zm35.5498-8.5a.48964.48964,0,0,1,.4502.51025v21.48a.48918.48918,0,0,1-.4502.50977H35.2002a.48918.48918,0,0,1-.4502-.50977v-21.48a.48964.48964,0,0,1,.4502-.51025H68.7998ZM10.75,19.26025a.48964.48964,0,0,1,.4502-.51025H44.7998a.48964.48964,0,0,1,.4502.51025V35.25H35.2002A1.98329,1.98329,0,0,0,33.25,37.26025V41.25H11.2002a.48918.48918,0,0,1-.4502-.50977Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,52.75h8a.7502.7502,0,0,0,.75-.75V44a.7502.7502,0,0,0-.75-.75H40a.7502.7502,0,0,0-.75.75v8A.7502.7502,0,0,0,40,52.75Zm.75-8h6.5v6.5h-6.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 31.25,
    width: 12,
    height: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,34.75h8a.7502.7502,0,0,0,.75-.75V26a.7502.7502,0,0,0-.75-.75H16a.7502.7502,0,0,0-.75.75v8A.7502.7502,0,0,0,16,34.75Zm.75-8h6.5v6.5h-6.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.46973,24.53027l4,4a.74971.74971,0,0,0,1.06054,0l4-4-1.06054-1.06054-2.80713,2.807A18.76948,18.76948,0,0,0,48,9.25v1.5A17.26988,17.26988,0,0,1,65.13574,26.0752l-2.60547-2.60547Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 49.25,
    width: 12,
    height: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27.25,
    width: 12,
    height: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.53027,55.46973l-4-4a.74972.74972,0,0,0-1.06054,0l-4,4,1.06054,1.06054,2.80713-2.807A18.76948,18.76948,0,0,0,32,70.75v-1.5A17.26988,17.26988,0,0,1,14.86426,53.9248l2.60547,2.60547Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCiscoDigitalPlatformsAndTools);
export default __webpack_public_path__ + "static/media/icon_cisco_digital_platforms_and_tools.3fdc65e26557e65bf8cdbf766f69772f.svg";
export { ForwardRef as ReactComponent };